export default {
  siteName: 'Go Drink',
  dbUrl: 'https://www.thecocktaildb.com',
  apiUrl: 'https://go-drink-backend.vercel.app/',
  linkedin: 'https://www.linkedin.com/in/matheus-andrade23/',
  gitHub: 'https://github.com/MatheusAndrade23',
  programaThor: 'https://programathor.com.br/users/131799',
  repository: 'https://github.com/MatheusAndrade23/Go_Drink',
};
